<template>
  <div class="scorecard__container container">
    <ControlGroup>
      <Dropdown
        v-if="showAll && !category"
        :options="Object.keys(policyTypes)"
        v-model="selectedPolicyType"
        label="Policy category"
      />
      <Dropdown
        v-if="!showAll"
        :options="countries"
        v-model="selectedCountry"
        label="Region"
        nullLabel="Select a country/region"
      />
    </ControlGroup>
    <template v-if="showAll">
      <PolicyScorecard
        :debug="debug"
        key="countriesScorecard"
        :params="{ topic: ['Critical Minerals'] }"
        :xCategories="policyTypes[selectedPolicyType]"
        :yCategories="
          countries.map((country) => ({ name: country, params: { country } }))
        "
      />
    </template>
    <template v-else>
      <template v-if="selectedCountry">
        <PolicyScorecard
          :debug="debug"
          v-for="category in Object.keys(policyTypes)"
          :key="`${category}scorecard`"
          :params="{ country: [selectedCountry] }"
          :yCategories="[
            { name: category, params: { topic: ['Critical Minerals'] } },
          ]"
          :xCategories="policyTypes[category]"
        />
      </template>
    </template>
  </div>
</template>

<script>
import {
  PolicyScorecard,
  ControlGroup,
  Dropdown,
} from "@international-energy-agency/vue-ui";
import policyTypes from "../data/policyTypes";
export default {
  props: {
    showAll: {
      type: Boolean,
      default: false,
    },
    countries: {
      type: Array,
      required: true,
    },
    category: {
      type: String,
      required: false,
    },
    debug: {
      type: Boolean,
      default: false,
    },
  },
  components: { PolicyScorecard, ControlGroup, Dropdown },
  data() {
    return {
      policyTypes,
      selectedCountry: null,
      selectedPolicyType: this.category || Object.keys(policyTypes)[0],
    };
  },
};
</script>
